//---------------------------------------------------------------------------------------------------
//  ?                              USE ORDER LEVELS HISTORY
//  @author         :  DeeTrade Team
//  @createdOn      :  04/16/2026
//  @description    :  Fetches prior trades (with level_history) for a strategy instance.
//                     Seeds the live chart's `levelHistory` on tab mount so closed trades
//                     render the same way a backtest does.
//---------------------------------------------------------------------------------------------------

import { useEffect, useState, useCallback } from 'react';
import api from '../../services/api';

export function useOrderLevelsHistory(strategyInstanceId, { limit = 50 } = {}) {
    const [trades, setTrades] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchOnce = useCallback(async () => {
        if (!strategyInstanceId) return;
        setIsLoading(true);
        setError(null);
        try {
            const resp = await api.get('/order-levels/trades', {
                params: { strategy_instance_id: strategyInstanceId, limit },
            });
            const payload = resp?.data?.data || {};
            setTrades(Array.isArray(payload.trades) ? payload.trades : []);
        } catch (err) {
            setError(err?.message || 'Failed to load prior trades');
            setTrades([]);
        } finally {
            setIsLoading(false);
        }
    }, [strategyInstanceId, limit]);

    useEffect(() => {
        fetchOnce();
    }, [fetchOnce]);

    return { trades, isLoading, error, refetch: fetchOnce };
}
